import { render, staticRenderFns } from "./profile-manager-scope.vue?vue&type=template&id=a86c84d2"
import script from "./profile-manager-scope.vue?vue&type=script&lang=js"
export * from "./profile-manager-scope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports